import {useState} from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Markdown from 'react-markdown'

const AccordionItem = ({question = "", answer = "", open = false}) => {
    return (
        <div style={{marginBottom: '15px'}}>
            <Accordion defaultExpanded={open}>
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                    <Typography>{question}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Markdown>{answer}</Markdown>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

const AccordionList = ({items, openFirst}) => {
    return items.map(({question, answer}, index) => (
        <AccordionItem
            open={openFirst && index === 0 ? true : false}
            key={`panel${index}`}
            question={question}
            answer={answer}
        />
    ));
};

export default AccordionList;
